var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.isComponent,{tag:"component",attrs:{"pulldata":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }